import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp.js";
import { AppHelper } from "../../appHelper.js";
import { Helper } from "../../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { Config } from "../../core/config/config.js";
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
export class EditIcon extends React.Component<IconProps, any>{
    closeAfterSave: boolean;
    translations: StringKeyDictionary<string>;
    common = new AppHelper();

    constructor(props: IconProps) {
        super(props)
        this.closeAfterSave = props.closeAfterSave;
        this.common.enableHooks = false;
        this.common.init(this);
        this.props.context.translations = this.translations;
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.HexCode":
            case "entity.Color":
                value = value.toUpperCase()
                break;
            default:
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private validate = async () => {
        if (!Helper.isHex(this.props.entity.HexCode)) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.SendStatus.NotHex"))
            return false;
        }

        if (!this.common.validate())
            return false;


        const result = await HTTPService.noBusyIndicator().get<JsonResultClass<any[]>>("Icon/GetAllIcons");
        if (result.Code !== 0) {
            NotificationHelper.showErrorMessage(result.Message)
            return false;
        }

        const item = result.Data.find(f => f.Id != this.props.entity.Id && f.HexCode == this.props.entity.HexCode);

        if (!Helper.hasValue(item))
            return true;
        const isOK = await DialogHelper.confirm(this.translations["WebSMS.ResourcePlanningScheduler.Icon.AlreadyUsed"].replace("{code}", item.HexCode).replace("{name}", item.Name))
        return isOK
    }

    save = async () => {
        const isValid = await this.validate();
        if (isValid) {
            const result = await HTTPService.post<JsonResultClass<IconEntity>>("Icon/Save", { model: this.props.entity });
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                Helper.updateEntity(this.props.entity, result.Data);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, this.closeAfterSave);
            this.setState({}, this.setTitle);
        }
    }

    private setTitle = () => {
        const l = Helper.hasValue(this.props.entity.Translations) ? this.props.entity.Translations.find(f => f.Key == Config.user.languageId) : null;
        const title = Helper.hasValue(l) && !Helper.isNullOrEmpty(l.Value) ? l.Value : this.props.entity.FallbackName;
        this.common.updateSheetTitle(title);
    }

    componentDidMount() {
        this.setTitle();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface IconProps extends AppBaseProps {
    entity: IconEntity;
    context: IconContext;
    closeAfterSave: boolean;
}

export interface IconContext extends Context {
    translations?: StringKeyDictionary<string>
}

export interface IconEntity extends Entity {
    Id: string;
    HexCode: string;
    FallbackName: string;
    Translations: KeyValuePair<number, string>[];
}